import { Box, IconButton, Image, Flex } from "@chakra-ui/react";
import { useState } from "react";
import { GrNext } from "react-icons/gr";
import { GrPrevious } from "react-icons/gr";

interface ImageSliderProps {
  images: string[];
  initialIndex?: number;
}

const CustomImageSlider: React.FC<ImageSliderProps> = ({
  images,
  initialIndex = 0,
}) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const totalImages = images.length;

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalImages);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? totalImages - 1 : prevIndex - 1
    );
  };

  return (
    <Box position="relative" maxW={"full"} mx="auto">
      <Image
        src={images[currentIndex]}
        alt={`Slide ${currentIndex + 1}`}
        width="100%"
        height={{ base: "full", md: "600px" }}
        objectFit="contain"
      />
      <Flex
        justify="space-between"
        align="center"
        position="absolute"
        top="50%"
        w="100%"
        transform="translateY(-50%)"
      >
        <IconButton
          aria-label="Previous Slide"
          icon={<GrPrevious color="brand.primary.DEFAULT" />}
          onClick={handlePrev}
          variant="solid"
          colorScheme="gray"
          size="lg"
          borderRadius="full"
          position="absolute"
          left={2}
        />

        <IconButton
          aria-label="Next Slide"
          icon={<GrNext color="brand.primary.DEFAULT" />}
          onClick={handleNext}
          variant="solid"
          colorScheme="gray"
          size="lg"
          borderRadius="full"
          position="absolute"
          right={2}
        />
      </Flex>
    </Box>
  );
};

export default CustomImageSlider;
